import {CouponListPage} from "../../domain/dtos/coupon-list-page";
import {CouponMapper} from "./coupon.mapper";

export class CouponListPageMapper {

    static deserialize(param: any): CouponListPage {
        return {
            totalPages: param.totalPages,
            totalResults: param.totalResults,
            coupons: param.results.map(CouponMapper.deserialize)
        } as CouponListPage
    }
}
